import DashboardLayout from '../dashboard';
import AuthGuard from '../../guards/AuthGuard';

export default function AuthGuardLayout() {
  return (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  );
}
